import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedSelect, {
  SelectOption,
} from "../../../components/essentials/input/select/AcedSelect";

const SelectCategory = () => {
  const { t } = useTranslation();

  const [categories, setCategories] = useState<SelectOption[]>([]);

  const { control, watch } = useFormContext();
  const watchSport = watch("sport");

  useEffect(() => {
    if (!watchSport) {
      setCategories([]);
      return;
    }

    const sportLabel = t("sportData.sportsLabels." + watchSport);
    setCategories([
      { value: "M", label: `${t("category.male")} ${sportLabel}` },
      { value: "F", label: `${t("category.female")} ${sportLabel}` },
    ]);
  }, [watchSport, t]);

  return (
    <AcedSelect
      label={t("createJob.categoryLabel")}
      control={control}
      name="category"
      options={categories}
      isDisabled={!watchSport}
      rules={{
        required: t("createJob.validation.required"),
      }}
    />
  );
};

export default SelectCategory;
